import { PagesCriticalCssFormValidationSchema } from '@/modules/Pages';

export const pageCriticalCssValidationSchema: PagesCriticalCssFormValidationSchema = {
  css: [{ type: 'string', message: 'Контент має бути строкового типу' }],
};
